/**
 * Normalizes stored userPart.availableTime for display by locale.
 * Stored shape from SendReport: "{date}{' เวลา '|' at '}{HH:mm} - {HH:mm}"
 * Legacy Thai used month:'short' which often still shows English month names (Apr).
 */

const TH_MONTHS = [
  'มกราคม',
  'กุมภาพันธ์',
  'มีนาคม',
  'เมษายน',
  'พฤษภาคม',
  'มิถุนายน',
  'กรกฎาคม',
  'สิงหาคม',
  'กันยายน',
  'ตุลาคม',
  'พฤศจิกายน',
  'ธันวาคม',
]

const TH_SHORT_MONTHS = [
  'ม.ค.',
  'ก.พ.',
  'มี.ค.',
  'เม.ย.',
  'พ.ค.',
  'มิ.ย.',
  'ก.ค.',
  'ส.ค.',
  'ก.ย.',
  'ต.ค.',
  'พ.ย.',
  'ธ.ค.',
]

const EN_SHORT = {
  jan: 0,
  feb: 1,
  mar: 2,
  apr: 3,
  may: 4,
  jun: 5,
  jul: 6,
  aug: 7,
  sep: 8,
  sept: 8,
  oct: 9,
  nov: 10,
  dec: 11,
}

function parseDatePart(datePart) {
  const s = datePart.trim()
  let d = new Date(s)
  if (!Number.isNaN(d.getTime())) return d

  // รองรับ format DD/MM/YYYY (ทั้ง ค.ศ. และ พ.ศ.)
  const slashFmt = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
  if (slashFmt) {
    const day = parseInt(slashFmt[1], 10)
    const month = parseInt(slashFmt[2], 10) - 1
    let year = parseInt(slashFmt[3], 10)
    if (year > 2400) year -= 543 // แปลง พ.ศ. เป็น ค.ศ.
    if (day >= 1 && day <= 31 && month >= 0 && month <= 11) {
      return new Date(year, month, day)
    }
  }

  const th = s.match(/^(\d{1,2})\s+(.+?)\s+(\d{4})$/)
  if (th) {
    const day = parseInt(th[1], 10)
    let year = parseInt(th[3], 10)
    if (year > 2400) year -= 543 // Convert BE to AD
    const monthStr = th[2].trim()
    let mi = TH_MONTHS.indexOf(monthStr)
    if (mi < 0) {
      mi = TH_SHORT_MONTHS.indexOf(monthStr)
    }
    if (mi < 0) {
      const normalizedWithDot = monthStr.endsWith('.') ? monthStr : `${monthStr}.`
      mi = TH_SHORT_MONTHS.indexOf(normalizedWithDot)
    }
    if (mi >= 0 && day >= 1 && day <= 31) {
      return new Date(year, mi, day)
    }
  }

  const en = s.match(/^(\d{1,2})\s+([A-Za-z]{3,4})\s+(\d{4})$/)
  if (en) {
    const day = parseInt(en[1], 10)
    let year = parseInt(en[3], 10)
    if (year > 2400) year -= 543 // Handle potentially stored BE
    const key = en[2].toLowerCase()
    const mi = EN_SHORT[key]
    if (mi != null && day >= 1 && day <= 31) {
      return new Date(year, mi, day)
    }
  }

  return null
}

/**
 * @param {string} raw
 * @param {'th'|'en'} localeLang
 * @returns {string}
 */
export function formatAvailableTimeDisplay(raw, localeLang) {
  if (raw == null || raw === '') return raw
  const trimmed = String(raw).trim()
  if (trimmed === '00:00 - 00:00') return trimmed

  const timeRangeRe = /^(.+?)(\d{1,2}:\d{2})\s*-\s*(\d{1,2}:\d{2})\s*$/
  const m = trimmed.match(timeRangeRe)
  if (!m) return raw

  let beforeFirstTime = m[1]
  const startT = m[2]
  const endT = m[3]

  const sepMatch = beforeFirstTime.match(/^(.*?)(?:\s*(?:เวลา|at)\s*)$/i)
  const datePart = (sepMatch ? sepMatch[1] : beforeFirstTime).trim()
  const sep = localeLang === 'en' ? ' at ' : ' เวลา '

  const parsed = parseDatePart(datePart)
  if (!parsed) {
    const cleanDate = datePart.replace(/(?:เวลา|at)$/i, '').trim()
    return `${cleanDate}${sep}${startT}\u00A0-\u00A0${endT}`
  }

  if (localeLang === 'th') {
    const day = String(parsed.getDate()).padStart(2, '0')
    const month = String(parsed.getMonth() + 1).padStart(2, '0')
    const year = parsed.getFullYear() + 543 // แปลงเป็น พ.ศ.
    const dStr = `${day}/${month}/${year}`
    return `${dStr}${sep}${startT}\u00A0-\u00A0${endT}`
  }

  const day = String(parsed.getDate()).padStart(2, '0')
  const month = String(parsed.getMonth() + 1).padStart(2, '0')
  const year = parsed.getFullYear()
  const dStr = `${day}/${month}/${year}`
  return `${dStr}${sep}${startT}\u00A0-\u00A0${endT}`
}
